export const SSO_MODES = {
  AGIS: 'agis_mode_sso'
};
